export default "__VITE_ASSET__CZCdA9ra__"